// extracted by mini-css-extract-plugin
export default {"link":"LinkToResource_link__+oalk","link-title":"LinkToResource_link-title__s380w"};